import { schema } from 'prose-core'

export const PreviewNodes = [
  schema.nodes.heading.create({}, schema.text('This is a Title')),
  schema.nodes.paragraph.create(
    {},
    schema.text(
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
    ),
  ),
  schema.nodes.heading.create({ level: 2 }, schema.text('This is Header 1')),
  schema.nodes.paragraph.create(
    {},
    schema.text(
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
    ),
  ),
  schema.nodes.heading.create({ level: 3 }, schema.text('This is Header 2')),
  schema.nodes.paragraph.create(
    {},
    schema.text(
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
    ),
  ),
  schema.nodes.heading.create({ level: 4 }, schema.text('This is Header 3')),
  schema.nodes.paragraph.create(
    {},
    schema.text(
      'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
    ),
  ),
]
